/** A small initials circle. There is no shared Avatar; the design uses one beside names (MPN-2171). */
export default function InitialsAvatar({ name, size }: { name: string; size: number }) {
    const initials = name
        .split(/[\s@.]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join("");
    return (
        <span className="banner-avatar" style={{ width: size, height: size, fontSize: size * 0.42 }} aria-hidden="true">
            {initials}
        </span>
    );
}
